import { apiRequest } from './api';

export const internalAuditApi = {
  getModuleAccessUsers: async () => apiRequest('/internal-audit/module-access/'),

  updateModuleAccessUsers: async (userIds) =>
    apiRequest('/internal-audit/module-access/', {
      method: 'PUT',
      body: JSON.stringify({ user_ids: userIds }),
    }),
};

export default internalAuditApi;
